import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  language: 'en', // Default language
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    changeLanguage(state, action) {
      state.language = action.payload; // Update the language state
    },
  },
});

export const { changeLanguage } = languageSlice.actions;
export default languageSlice.reducer;
